import React, {useState, useEffect, Fragment} from "react";
import PropTypes from "prop-types";
import {UncontrolledTooltip} from "reactstrap";

/** This component will display reactstrap tooltip when content is overflowing from element */

const Tooltip = (props) => {
  const {target, placement = "auto", overflowType = "width", tooltip} = props;
  const [isOverflow, setIsOverflow] = useState(false);
  const [content, setContent] = useState("");

  useEffect(() => {
    const element = document.getElementById(target);

    if (!element) {
      return undefined;
    }

    const frameId = requestAnimationFrame(() => {
      const overflow =
        overflowType === "width"
          ? element.scrollWidth > element.offsetWidth
          : element.scrollHeight > element.offsetHeight;

      setIsOverflow(overflow);
      setContent(element.textContent);
    });

    return () => {
      cancelAnimationFrame(frameId);
    };
  }, [target, overflowType, tooltip]);

  return (
    <Fragment>
      {isOverflow && (
        <UncontrolledTooltip target={target} placement={placement}>
          {tooltip ?? content}
        </UncontrolledTooltip>
      )}
    </Fragment>
  );
};

Tooltip.propTypes = {
  /** id of element on which tooltip needs to be displayed
   *  when content is overflowing from element */
  target: PropTypes.string.isRequired,
  /** Placement of tooltip on element */
  placement: PropTypes.string,
  /** If set to width check for horizontal overflow
   *  If set to height check for vertical overflow
   */
  overflowType: PropTypes.oneOf(["width", "height"]),
  /** Text to be displayed in tooltip.
   * By default tooltip will show content of element
   */
  tooltip: PropTypes.string,
};

export default Tooltip;
